var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedrooms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2164 18.127H1.85278V34.036H43.2164V18.127Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2163 35.627V18.127",
    stroke: "black",
    strokeWidth: 3.18182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85278 35.627V18.127",
    stroke: "black",
    strokeWidth: 3.18182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4436 0.626953H6.62542C4.86747 0.626953 3.4436 2.05082 3.4436 3.80877V14.9451H6.62542V11.7633C6.62542 10.8851 7.33815 10.1724 8.21633 10.1724H19.3527C20.2309 10.1724 20.9436 10.8851 20.9436 11.7633V14.9451H24.1254V11.7633C24.1254 10.8851 24.8382 10.1724 25.7163 10.1724H36.8527C37.7309 10.1724 38.4436 10.8851 38.4436 11.7633V14.9451H41.6254V3.80877C41.6254 2.05082 40.2016 0.626953 38.4436 0.626953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedrooms);
export default __webpack_public_path__ + "static/media/bedrooms.149b15d966ad66f25d0c8cffc5d96e8e.svg";
export { ForwardRef as ReactComponent };